export const EXPLAINER = 'EXPLAINER';
export const INSTALL_APP = 'INSTALL_APP';
export const OPEN_APP = 'OPEN_APP';
export const QR_CODE_HELP = 'QR_CODE_HELP';
export const SECOND_APPLICANT = '/second-applicant/';
